import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import './styles/navbar.css';
import { Facebook, Instagram, Phone, Mail, Menu, X } from 'lucide-react';
import SearchComponent from './search';
import yorkLogo from './assets/york.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handlePhoneClick = () => {
    window.location.href = 'tel:9818207704';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:info@yorkengineering.com.np';
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="navbar-container">
      <div className="top-bar">
        <div className="follow-us">
          <span>Follow us:</span>
          <div className="social-icons">
            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer">
              <Facebook size={18} color="#ffffff" />
            </a>
            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
              <Instagram size={18} color="#ffffff" />
            </a>
          </div>
        </div>
        <div className="contact-info">
          <div className="info clickable" onClick={handlePhoneClick}>
            <Phone size={18} color="#FFFFFF" />
            <span>9818207704</span>
          </div>
          <div className="info clickable" onClick={handleEmailClick}>
            <Mail size={18} color="#FFFFFF" />
            <span>info@yorkengineering.com.np</span>
          </div>
        </div>
      </div>

      <div className="main-navbar" ref={menuRef}>
        <NavLink to="/" onClick={handleLinkClick}>
          <img className="logo" src={yorkLogo} alt="York Engineering Logo" />
        </NavLink>
        <div className="menu-icon" onClick={handleMenuToggle}>
          {isMenuOpen ? (
            <X size={24} color="#222222" />
          ) : (
            <Menu size={24} color="#222222" />
          )}
        </div>
        <div className={`menu-items ${isMenuOpen ? 'open' : ''}`}>
          <NavLink 
            to="/" 
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            Home
          </NavLink>
          <NavLink 
            to="/about" 
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            About us
          </NavLink>
          <NavLink 
            to="/products" 
            className={({ isActive }) => `menu-link ${isActive || window.location.pathname.includes('/product/') || window.location.pathname.startsWith('/products/') ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            Products
          </NavLink>
          <NavLink 
            to="/ordernow" 
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            Request a Quote
          </NavLink>
          <NavLink 
            to="/contact" 
            className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            Contact us
          </NavLink>
          <div className="mobile-search">
            <SearchComponent onClose={() => setIsMenuOpen(false)} />
          </div>
        </div>
        <div className="desktop-search">
          <SearchComponent />
        </div>
      </div>
    </div>
  );
};

export default Navbar;